/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { css, jsx } from "@compiled/react";

import Heading from "@atlaskit/heading";
import { Stack, Text } from "@atlaskit/primitives";
import { N0, N800 } from "@atlaskit/theme/colors";
import { token } from "@atlaskit/tokens";

const styles = {
    siteSetupHeaderDescriptionHighlightStyles: css({
        color: token("color.text.inverse", N0),
        fontWeight: 600
    }),
    // This style configuration is required to ensures that the title and description text colors revert to neutral when the background image is hidden on smaller screens.
    colorToggle: css({
        "@media (max-width: 664px)": {
            color: `${token("color.text", N800)}`
        }
    })
};

interface SiteSetupHeaderProps {
    title: string;
    description: string;
    descriptionHighlight?: string;
}

export const SiteSetupHeader = ({
    title,
    description,
    descriptionHighlight
}: SiteSetupHeaderProps) => {
    return (
        <Stack alignInline="center" space="space.100">
            <Heading color="inverse" size="xlarge">
                <span css={styles.colorToggle}>{title}</span>
            </Heading>
            <Text color="color.text.inverse">
                <span css={styles.colorToggle}>{description}</span>
                {descriptionHighlight && (
                    <span
                        css={[
                            styles.siteSetupHeaderDescriptionHighlightStyles,
                            styles.colorToggle
                        ]}
                    >
                        {descriptionHighlight}
                    </span>
                )}
            </Text>
        </Stack>
    );
};
